import moment from "moment";
import { convertFuelBurnedToCo2 } from "@signolteam/shared/utils";

/** @example roundDownToNearestIncrement(-125, 100) // -100 */
export const roundUpToNearestIncrement = (value, increment) => {
  return increment * Math.ceil(value / increment);
};
/** @example roundDownToNearestIncrement(758, 250) // 750 */
export const roundDownToNearestIncrement = (value, increment) => {
  return increment * Math.floor(value / increment);
};

/** @deprecated replace with `formatMass(convertFuelBurnedToCo2(x))` both from @signolteam/shared */
export const calculateCO2Convertion = (fromJetFuelValueKG, toRate = 1) => {
  /** TODO: swap the display part with SignolUtils.getNumberFormatterForUnit or formatMass from "@signolteam/shared/units-of-measure" */
  let res = convertFuelBurnedToCo2(fromJetFuelValueKG) / toRate;
  if (res <= 1) {
    return res.toFixed(2);
  }
  return Math.round(res).toFixed(0);
};

export const calculateCO2Tonnes = (fromFuelValueKG) => {
  /** TODO: swap the display part with SignolUtils.getNumberFormatterForUnit or formatMass from "@signolteam/shared/units-of-measure" */
  let res = convertFuelBurnedToCo2(fromFuelValueKG) / 1000;
  if (res > 0.25) {
    res = roundDownToNearestIncrement(res, 0.25); // rounded by 250kg CO2
    if (res > 1) {
      res = roundDownToNearestIncrement(res, 0.5); // > 1 tonne -> rounded by 500kg CO2
      if (res > 10) {
        res = Math.floor(res); // > 10 tonnes -> no decimals
        return res.toFixed(0);
      }
      return res.toFixed(1);
    }
    return res.toFixed(2);
  }
  return res.toFixed(2);
};

/**
 * Format a number as a nice string, with thousands separators etc.
 * @param {boolean} toFixed if true the decimal portion is removed, like number.toFixed()
 * @deprecated Replace with formatNumber from "@signolteam/shared/units-of-measure"
 */
export const formatNumber = (value, toFixed) => {
  const formatSettings = toFixed ? { maximumFractionDigits: 0 } : {};
  return new Intl.NumberFormat("en-US", formatSettings).format(value);
};

/** @deprecated Replace with formatCurrency from "@signolteam/shared/units-of-measure" */
export const convertCurrency = (value) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  })
    .format(value)
    .replace(/\D00$/, "")
    .replace("$", "");
};

export const dateTinyFormatterUTC = (dateTimeUnix) => {
  return moment.utc(dateTimeUnix).format("MMM DD");
};

export const dateShortFormatterUTC = (dateTimeUnix) => {
  return moment.utc(dateTimeUnix).format("MMM DD, YYYY");
};

export const formatMonthYear = (dateTimeUnix) => {
  return moment.utc(dateTimeUnix).format("MMMM YYYY");
};

export const dateFormatterUTC = (dateTimeUnix) => {
  return moment.utc(dateTimeUnix).format("MMMM DD, YYYY");
};

export const datetimeTinyFormatterUTC = (dateTimeUnix) => {
  return moment.utc(dateTimeUnix).format("MMM DD, HH:mm");
};

export const datetimeShortFormatterUTC = (dateTimeUnix) => {
  return moment.utc(dateTimeUnix).format("MMM DD, YYYY HH:mm");
};

export const datetimeFormatterUTC = (dateTimeUnix) => {
  return moment.utc(dateTimeUnix).format("MMMM DD, YYYY HH:mm");
};

export const dateFancyFormatterUTC = (dateTimeUnix) => {
  return moment.utc(dateTimeUnix).format("Do MMM");
};

export const formatTime = (dateTimeUnix) => {
  return moment.utc(dateTimeUnix).format("HH:mm");
};

/** @returns {number} rounded to at most 2 decimal places */
export const roundTo2DP = (n) => {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
};
